import { Component, Input, OnChanges } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { AttributePresenceInput } from "@spscommerce/ng-utils";
import { tickDelay } from "@spscommerce/utils";
import { filter } from "rxjs/operators";

@Component({
    selector: "sps-side-nav",
    templateUrl: "./sps-side-nav.component.html"
})
export class SpsSideNavComponent implements OnChanges {
    @Input() navTree;
    @Input() @AttributePresenceInput() filterable: boolean;

    _navTreeInternal;
    tabs;
    activeTabId;
    filter = "";

    constructor(
        private router: Router
    ) {
        router.events.pipe(
            filter<NavigationEnd>(e => e instanceof NavigationEnd)
        ).subscribe(e => this.setActiveTabId(e.url));
    }

    static alterTree(branch) {
        const childrenList = [];
        for (const key of Object.keys(branch.children)) {
            const child = branch.children[key];
            const branchPath = branch.path || "";
            child.path = child.skipRouting ? branchPath : `${branchPath}/${key}`;
            SpsSideNavComponent.alterTree(child);
            childrenList.push(child);
        }
        branch.children = childrenList;
    }

    @tickDelay
    ngOnChanges() {
        SpsSideNavComponent.alterTree(this.navTree);
        this._navTreeInternal = this.navTree;
        this.tabs = this.navTree.tabs ? this._navTreeInternal : null;
        this.setActiveTabId(this.router.routerState.snapshot.url);
    }

    setActiveTabId(url) {
        if (this.tabs) {
            const activeTab = this.tabs.children.find(c => url.indexOf(c.path) === 0);
            if (activeTab) {
                this.activeTabId = activeTab.name;
            }
        }
    }

    onTabChange(newTab) {
        this.router.navigateByUrl(this.tabs.children.find(t => t.name === newTab.label).path);
    }

    branchIsDeep(branch) {
        return branch && branch.children && branch.children.some(c => c.children && c.children.length);
    }
}
